import Home from "./PAGE/Home";
import Footer from "./Comps/HEADERandFOOTER/Footer";
import Navbar from "./Comps/HEADERandFOOTER/Navbar";
import "./Comps/css/Subject.css"; // Adjusted path for consistency
import DashBoard from "./PAGE/DashBoard";
import InsertData from "./PAGE/InsertData";
import Pp02Insertion from "./Comps/InsertData/Pp02Insertion";
import InterchangeInsertion from "./Comps/InsertData/InterchangeInsertion";
import PpLostTrainInsertion from "./Comps/InsertData/PpLostTrainInsertion";
import PDDInsertion from "./Comps/InsertData/PDD/PDDInsertion";
import PWIInsertion from "./Comps/InsertData/PWIInsertion";
import Login from "./PAGE/LogIn";
import PrivateRoute from "./Comps/PrivateRoute";
import { Toaster } from "react-hot-toast";
import { useGlobalContext } from "./Comps/Context/GlobalContext";
import ShowToastMsg from "./Comps/Extra/ShowToastMsg";
import BlockDataInsertion from "./Comps/InsertData/BlockDataInsertion";
import BlockDashBoard from "./PAGE/BlockDashBoard";
import IREMaster from "./Comps/InsertData/IREMaster";
import ADRMBlockPositionInsertion from "./Comps/InsertData/ADRMBlockPositionInsertion";
import CrackMaster from "./Comps/InsertData/CrackMaster";
import AdminHome from "./Comps/ADMIN/AdminHome";
import AdminControlPanel from "./Comps/ADMIN/AdminControlPanel";
import TWSBlockUpdate from "./Comps/InsertData/TWSBlock/TWSBlockUpdate";
import CrewMaster from "./Comps/InsertData/CrewInsertion/CrewMaster";
import PathWastageMaster from "./Comps/InsertData/PathWastage/PathWastageMaster";
import NonWorkingMaster from "./Comps/InsertData/NonWorking/NonWorkingMaster";
import PDFInsertionMaster from "./Comps/InsertData/PDFInsertion/PDFInsertionMaster";
import PDDMaster from "./Comps/InsertData/PDD/PDDMaster";
import CMS from "./PAGE/CMS";
import PointWiseInterchangeMaster from "./Comps/Reports/Others/PointWiseInterchange/PointWiseInterchangeMaster";
import InterChangeMaster from "./Comps/InsertData/InterChange/InterChangeMaster";
import PWIInsertionMaster from "./Comps/InsertData/PWI/PWIInsertionMaster";
import PPLostTrainMaster from "./Comps/InsertData/PPLostTrain/PPLostTrainMaster";
import LongHaulTOMaster from "./Comps/InsertData/LongHaul/LongHaulTOMaster";
import LongHaulHOMaster from "./Comps/InsertData/LongHaul/LongHaulHOMaster";
import TWSCautionMaster from "./Comps/InsertData/TWS Caution/TWSCautionMaster";
import StationMap from "./PAGE/StationMap";
import SMInsMaster from "./Comps/InsertData/StationMapInsertion/SMInsMaster";
import NKJExaminationInsMaster from "./Comps/InsertData/NKJExamination/NKJExaminationInsMaster";
import NKJTerminalDetentionInsMaster from "./Comps/InsertData/NKJTerminalDetention/NKJTerminalDetentionInsMaster";
import NKJTrafficFlowInsMaster from "./Comps/InsertData/NkjTraifficFlow/NKJTrafficFlowInsMaster";
import AssetFailureInsertion from "./Comps/InsertData/AssetFailureInsertion/AssetFailureInsertion";
import ClearanceAndSupply from "./PAGE/ClearanceAndSupply";
import ClsLoadingMaster from "./Comps/InsertData/Cls/ClsLoading/ClsLoadingMaster";
import CLSIndentMaster from "./Comps/InsertData/Cls/IndentInsertion/CLSIndentMaster";
import DynamicInsertionMaster from "./Comps/InsertData/Dynamic insertion/DynamicInsertionMaster";
import StoreInsMaster from "./Comps/InsertData/StoreInsertion/StoreInsMaster";
import Store from "./PAGE/Store";
import InitiateProcurement from "./Comps/InsertData/StoreInsertion/Procurement/InitiateProcurement";
import ProcurementMaster from "./Comps/InsertData/StoreInsertion/Procurement/ProcurementMaster";
import MessagingMaster from "./Comps/InsertData/Messaging/InsertMsg/MessagingMaster";
import DynamicReport from "./PAGE/DynamicReport";
const admin = ["admin"];
const staff = ["admin", "dataEntry"];
const all = ["admin", "dataEntry", "user"];
export const appRoutes = [
  // ===================== HOME =====================
  {
    path: "/",
    component: Home,
    roles: all,
  },
  {
    path: "/DashBoard",
    component: DashBoard,
    roles: all,
  },
  {
    path: "/BlockDashBoard",
    component: BlockDashBoard,
    roles: all,
  },
  {
    path: "/CMS",
    component: CMS,
    roles: all,
  },
  {
    path: "/StationMap",
    component: StationMap,
    roles: all,
  },
  {
    path: "/DynamicReport",
    component: DynamicReport,
    roles: admin,
  },

  // ====================== STORE  ===============================
  {
    path: "/Store",
    component: Store,
    roles: all,
  },
  // ===================== INSERT DATA =====================
  {
    path: "/InsertData",
    component: InsertData,
    roles: staff,
  },
  {
    path: "/InsertData/Pp02Insertion",
    component: Pp02Insertion,
    roles: staff,
    permission: "Pp02Insertion",
  },
  {
    path: "/InsertData/PpLostTrainInsertion",
    component: PPLostTrainMaster,
    roles: staff,
    permission: "PpLostTrainInsertion",
  },
  {
    path: "/InsertData/InterchangeInsertion",
    component: InterChangeMaster,
    roles: staff,
    permission: "InterchangeInsertion",
  },
  {
    path: "/InsertData/PDDInsertion",
    component: PDDMaster,
    roles: staff,
    permission: "PDDInsertion",
  },
  {
    path: "/InsertData/asset_failure",
    component: AssetFailureInsertion,
    roles: staff,
    permission: "asset_failure",
  },
  {
    path: "/InsertData/TWSBlockUpdate",
    component: TWSBlockUpdate,
    roles: staff,
    permission: "TWSBlockUpdate",
  },
  {
    path: "/InsertData/PWIInsertion",
    component: PWIInsertionMaster,
    roles: staff,
    permission: "PWIInsertion",
  },
  {
    path: "/InsertData/IreInsertion",
    component: IREMaster,
    roles: staff,
    permission: "IreInsertion",
  },
  {
    path: "/InsertData/CrackInsertion",
    component: CrackMaster,
    roles: staff,
    permission: "CrackInsertion",
  },
  {
    path: "/InsertData/PDFInsertion",
    component: PDFInsertionMaster,
    roles: staff,
    permission: "PDFInsertion",
  },
  {
    path: "/InsertData/LongHaulTOInsertion",
    component: LongHaulTOMaster,
    roles: staff,
    permission: "LongHaulTOInsertion",
  },
  {
    path: "/InsertData/LongHaulHOInsertion",
    component: LongHaulHOMaster,
    roles: staff,
    permission: "LongHaulHOInsertion",
  },
  {
    path: "/InsertData/NKJTrafficFlowInsertion",
    component: NKJTrafficFlowInsMaster,
    roles: staff,
    permission: "NKJTrafficFlowInsertion",
  },
  {
    path: "/InsertData/NKJTerminaldetentionInsertion",
    component: NKJTerminalDetentionInsMaster,
    roles: staff,
    permission: "NKJTerminaldetentionInsertion",
  },
  {
    path: "/InsertData/NKJExaminationInsertion",
    component: NKJExaminationInsMaster,
    roles: staff,
    permission: "NKJExaminationInsertion",
  },

  // ===================== BLOCK =====================
  {
    path: "/InsertData/BlockDataInsertion",
    component: BlockDataInsertion,
    roles: staff,
    permission: "BlockDataInsertion",
  },
  {
    path: "/InsertData/ADRMBlockPositionInsertion",
    component: ADRMBlockPositionInsertion,
    roles: staff,
    permission: "ADRMBlockPositionInsertion",
  },
  {
    path: "/InsertData/CrewDemandInsertion",
    component: CrewMaster,
    roles: staff,
    permission: "CrewDemandInsertion",
  },
  {
    path: "/InsertData/PathWastage",
    component: PathWastageMaster,
    roles: staff,
    permission: "PathWastage",
  },
  {
    path: "/InsertData/NonWorking",
    component: NonWorkingMaster,
    roles: staff,
    permission: "NonWorking",
  },
  {
    path: "/InsertData/TWSCautionInsertion",
    component: TWSCautionMaster,
    roles: staff,
    permission: "TWSCautionInsertion",
  },

  // ===================== STATION MAP =====================
  {
    path: "/InsertData/SMInsertion",
    component: SMInsMaster,
    roles: staff,
    permission: "SMInsertion",
  },
  // ===================== ClearanceAndSupply =====================
  {
    path: "/ClearanceAndSupply",
    component: ClearanceAndSupply,
    roles: all,
    permission: "ClearanceAndSupply",
  },
  // ====================== STORE InsertData ===============================
  {
    path: "/InsertData/Store/StoreInsMaster-division",
    component: StoreInsMaster,
    roles: staff,
    permission: "StoreInsMaster-division",
  },
  {
    path: "/InsertData/Store/StoreInsMaster-station",
    component: StoreInsMaster,
    roles: staff,
    permission: "StoreInsMaster-station",
  },
  {
    path: "/InsertData/Store/Initiate-Procurement",
    component: ProcurementMaster,
    roles: staff,
    permission: "Initiate-Procurement",
  },

  // ========================================================================
  {
    path: "/InsertData/MessagingMaster",
    component: MessagingMaster,
    roles: staff,
    permission: "MessagingMaster",
  },
  {
    path: "/InsertData/UpdateMessages",
    component: MessagingMaster,
    roles: staff,
    permission: "MessagingMaster",
  },
  // ===================== DYNAMIC =====================
  {
    path: "/InsertData/lp/DynamicInsertion",
    component: DynamicInsertionMaster,
    roles: staff,
    permission: "DynamicInsertion",
  },

  {
    path: "/InsertData/lp/ClsLoadingMaster/CLSIndentMaster",
    component: ClsLoadingMaster,
    roles: staff,
    permission: "CLSIndentMaster",
  },
  {
    path: "/InsertData/CLSInsertion/CLSIndentMaster",
    component: CLSIndentMaster,
    roles: staff,
    permission: "CLSIndentMaster",
  },

  // ===================== ADMIN =====================
  {
    path: "/adminPanel",
    component: AdminHome,
    roles: admin,
  },
  {
    path: "/adminPanel/Control",
    component: AdminControlPanel,
    roles: admin,
  },
];
